"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var RadioButton_component_exports = {};
__export(RadioButton_component_exports, {
  RadioButton: () => RadioButton,
  default: () => RadioButton_component_default
});
module.exports = __toCommonJS(RadioButton_component_exports);
var import_react = __toESM(require("react"));
var import_RadioButton = require("./RadioButton.styled");
var _excluded = ["label", "isSelected", "disabled", "ariaLabel", "darkMode"];
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function(n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t)
        ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
function _objectWithoutProperties(e, t) {
  if (null == e)
    return {};
  var o, r, i = _objectWithoutPropertiesLoose(e, t);
  if (Object.getOwnPropertySymbols) {
    var s = Object.getOwnPropertySymbols(e);
    for (r = 0; r < s.length; r++)
      o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
function _objectWithoutPropertiesLoose(r, e) {
  if (null == r)
    return {};
  var t = {};
  for (var n in r)
    if ({}.hasOwnProperty.call(r, n)) {
      if (e.includes(n))
        continue;
      t[n] = r[n];
    }
  return t;
}
var RadioButton = function RadioButton2(_ref) {
  var _ref$label = _ref.label, label = _ref$label === void 0 ? "" : _ref$label, _ref$isSelected = _ref.isSelected, isSelected = _ref$isSelected === void 0 ? false : _ref$isSelected, _ref$disabled = _ref.disabled, disabled = _ref$disabled === void 0 ? false : _ref$disabled, _ref$ariaLabel = _ref.ariaLabel, ariaLabel = _ref$ariaLabel === void 0 ? "" : _ref$ariaLabel, _ref$darkMode = _ref.darkMode, darkMode = _ref$darkMode === void 0 ? false : _ref$darkMode, props = _objectWithoutProperties(_ref, _excluded);
  var handlerValueSelected = function handlerValueSelected2(event) {
    return props.setValueSelected(event.target.value);
  };
  return /* @__PURE__ */ import_react.default.createElement(import_RadioButton.StyledRadio, {
    disabled,
    darkMode,
    "data-dp-analytics-id": props.dataDpAnalyticsId
  }, /* @__PURE__ */ import_react.default.createElement(import_RadioButton.StyledSpan, {
    className: "crossed-radio",
    disabled,
    isSelected
  }), /* @__PURE__ */ import_react.default.createElement(import_RadioButton.StyledInput, _extends({
    type: "radio",
    id: props.id,
    name: props.name,
    tabIndex: 0,
    value: props.value,
    checked: isSelected,
    onChange: handlerValueSelected,
    disabled,
    "aria-label": ariaLabel,
    darkMode
  }, props)), /* @__PURE__ */ import_react.default.createElement(import_RadioButton.StyledRadioBtn, {
    className: "radio-radio",
    disabled,
    isSelected,
    darkMode
  }), /* @__PURE__ */ import_react.default.createElement(import_RadioButton.StyledLabel, {
    htmlFor: props.id,
    disabled,
    darkMode
  }, label));
};
var RadioButton_component_default = RadioButton;
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  RadioButton
});
//# sourceMappingURL=RadioButton.component.js.map